import { render, staticRenderFns } from "./RemoveUser.vue?vue&type=template&id=3f557235&style=display%3A%20flex"
import script from "./RemoveUser.vue?vue&type=script&lang=js"
export * from "./RemoveUser.vue?vue&type=script&lang=js"
import style0 from "./RemoveUser.vue?vue&type=style&index=0&id=3f557235&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports